import { Province } from '../interfaces/prop.interface';

export const provincesJson: Province[] = [
    {
        id: "1",
        name: "Álava/Araba",
        lat: 42.85,
        lng: -2.683333,
    },
    {
        id: "2",
        name: "Albacete",
        lat: 39.0,
        lng: -1.866667,
    },
    {
        id: "3",
        name: "Alicante",
        lat: 38.35,
        lng: -0.483333,
    },
    {
        id: "4",
        name: "Almería",
        lat: 36.833333,
        lng: -2.45,
    },
    {
        id: "33",
        name: "Asturias",
        lat: 43.366667,
        lng: -5.85,
    },
    {
        id: "5",
        name: "Ávila",
        lat: 40.65,
        lng: -4.7,
    },
    {
        id: "6",
        name: "Badajoz",
        lat: 38.883333,
        lng: -6.966667,
    },
    {
        id: "7",
        name: "Baleares",
        lat: 39.566667,
        lng: 2.65,
    },
    {
        id: "8",
        name: "Barcelona",
        lat: 41.383333,
        lng: 2.183333,
    },
    {
        id: "9",
        name: "Burgos",
        lat: 42.35,
        lng: -3.7,
    },
    {
        id: "10",
        name: "Cáceres",
        lat: 39.466667,
        lng: -6.366667,
    },
    {
        id: "11",
        name: "Cádiz",
        lat: 36.533333,
        lng: -6.3,
    },
    {
        id: "39",
        name: "Cantabria",
        lat: 43.2,
        lng: -3.8,
    },
    {
        id: "12",
        name: "Castellón",
        lat: 39.983333,
        lng: -0.033333,
    },
    {
        id: "51",
        name: "Ceuta",
        lat: 35.883333,
        lng: -5.316667,
    },
    {
        id: "13",
        name: "Ciudad Real",
        lat: 38.983333,
        lng: -3.933333,
    },
    {
        id: "14",
        name: "Córdoba",
        lat: 37.883333,
        lng: -4.766667,
    },
    {
        id: "16",
        name: "Cuenca",
        lat: 40.066667,
        lng: -2.133333,
    },
    {
        id: "17",
        name: "Gerona/Girona",
        lat: 41.983333,
        lng: 2.816667,
    },
    {
        id: "18",
        name: "Granada",
        lat: 37.166667,
        lng: -3.583333,
    },
    {
        id: "19",
        name: "Guadalajara",
        lat: 40.633333,
        lng: -3.166667,
    },
    {
        id: "20",
        name: "Guipúzcoa/Gipuzkoa",
        lat: 43.316667,
        lng: -1.983333,
    },
    {
        id: "21",
        name: "Huelva",
        lat: 37.25,
        lng: -6.933333,
    },
    {
        id: "22",
        name: "Huesca",
        lat: 42.133333,
        lng: -0.4,
    },
    {
        id: "23",
        name: "Jaén",
        lat: 37.766667,
        lng: -3.783333,
    },
    {
        id: "15",
        name: "La Coruña/A Coruña",
        lat: 43.366667,
        lng: -8.4,
    },
    {
        id: "26",
        name: "La Rioja",
        lat: 42.466667,
        lng: -2.45,
    },
    {
        id: "35",
        name: "Las Palmas",
        lat: 28.1,
        lng: -15.416667,
    },
    {
        id: "24",
        name: "León",
        lat: 42.6,
        lng: -5.566667,
    },
    {
        id: "25",
        name: "Lérida/Lleida",
        lat: 41.616667,
        lng: 0.616667,
    },
    {
        id: "27",
        name: "Lugo",
        lat: 43.016667,
        lng: -7.55,
    },
    {
        id: "28",
        name: "Madrid",
        lat: 40.4,
        lng: -3.683333,
    },
    {
        id: "29",
        name: "Málaga",
        lat: 36.716667,
        lng: -4.416667,
    },
    {
        id: "52",
        name: "Melilla",
        lat: 35.3,
        lng: -2.95,
    }
    ,
    {
        id: "30",
        name: "Murcia",
        lat: 37.983333,
        lng: -1.133333,
    },
    {
        id: "31",
        name: "Navarra",
        lat: 42.816667,
        lng: -1.65,
    },
    {
        id: "32",
        name: "Orense/Ourense",
        lat: 42.333333,
        lng: -7.866667,
    },
    {
        id: "34",
        name: "Palencia",
        lat: 42.016667,
        lng: -4.533333,
    },
    {
        id: "36",
        name: "Pontevedra",
        lat: 42.433333,
        lng: -8.65,
    },
    {
        id: "37",
        name: "Salamanca",
        lat: 40.966667,
        lng: -5.65,
    },
    {
        id: "40",
        name: "Segovia",
        lat: 40.95,
        lng: -4.116667,
    },
    {
        id: "41",
        name: "Sevilla",
        lat: 37.383333,
        lng: -5.983333,
    },
    {
        id: "42",
        name: "Soria",
        lat: 41.766667,
        lng: -2.466667,
    },
    {
        id: "43",
        name: "Tarragona",
        lat: 41.116667,
        lng: 1.25,
    },
    {
        id: "38",
        name: "Tenerife",
        lat: 28.466667,
        lng: -16.25,
    },
    {
        id: "44",
        name: "Teruel",
        lat: 40.35,
        lng: -1.116667,
    },
    {
        id: "45",
        name: "Toledo",
        lat: 39.866667,
        lng: -4.016667,
    },
    {
        id: "46",
        name: "Valencia",
        lat: 39.466667,
        lng: -0.366667,
    },
    {
        id: "47",
        name: "Valladolid",
        lat: 41.65,
        lng: -4.716667,
    },
    {
        id: "48",
        name: "Vizcaya/Bizkaia",
        lat: 43.25,
        lng: -2.933333,
    },
    {
        id: "49",
        name: "Zamora",
        lat: 41.5,
        lng: -5.75,
    },
    {
        id: "50",
        name: "Zaragoza",
        lat: 41.65,
        lng: -0.883333,
    }
]